const THREE = require('three')
// import * as board from './board'
import * as cloth from './cloth'

export let mesh = new THREE.Object3D()
export default mesh
mesh.name = 'flag'

// mesh.add(board.mesh)
mesh.add(cloth.mesh)


// OLD ROTATE VERSION
// cloth.mesh.position.y = 590
// mesh.position.z = 0
// mesh.position.y = -630
// mesh.position.x = -80
// mesh.rotation.z = -180 * THREE.Math.DEG2RAD


// NEW SLIDE VERSION
let offset = [window.innerWidth * 1.2, window.innerHeight * 0.2, 0]

mesh.position.x =  10 + offset[0]
mesh.position.y = -60 + offset[1]
mesh.position.z =   0 + offset[2]

mesh.rotation.z = 14 * THREE.Math.DEG2RAD


// WEBPACK FOOTER //
// ./src/components/game/result/flag.js